/**
 * Module that is responsible for fetching and caching the taxonomies and taxonomy categories.
 * The taxonomies-api is only responsible for fetching the data from the api, this module in contrast
 * adds some caching functionality, so that taxonomies must not be fetched each time they are used.
 */
import { getAllTaxonomyCategories, TaxonomyCategory } from './api/taxonomies-api';

class TaxonomiesModule {
  /**
   * List of taxonomy categories and their taxonomies. This property is null
   * until it was fetched once from the API.
   */
  taxonomyCategories: TaxonomyCategory[] = null;

  /**
   * Get the taxonomy categories and their taxonomies. If they have not been cached yet, this
   * function makes a request to the taxonomies API. After that it will return the cached taxonomies.
   * @param forceUpdate Boolean If the taxonomies should be loaded from the API even if there exists a cached version.
   */
  async getCachedTaxonomyCategories(forceUpdate = false): Promise<TaxonomyCategory[]> {
    if (this.taxonomyCategories && !forceUpdate) {
      // If the taxonomies have been fetched already, return the cached ones
      return Promise.resolve(this.taxonomyCategories);
    }

    return new Promise((resolve) => {
      // Otherwise call the taxonomies API
      getAllTaxonomyCategories().then((taxonomyCategories) => {
        this.taxonomyCategories = taxonomyCategories;
        resolve(taxonomyCategories);
      });
    });
  }
}

const taxonomiesModule = new TaxonomiesModule();
export { taxonomiesModule as taxonomies };
